import React from 'react';

import './styles.css';

import formatDay from '../../../../functions/formatDay';

export default function CalendarDay(props) {

    function isSelected(day) {
        if (props.selectedDate.getDate() === day.getDate() &
            props.selectedDate.getMonth() === day.getMonth() &
            props.selectedDate.getFullYear() === day.getFullYear()
        ) return true;
        else return false;
    }

    function isToday(day) {
        var today = new Date();
        if (today.getDate() === day.getDate() &
            today.getMonth() === day.getMonth() &
            today.getFullYear() === day.getFullYear()
        ) return true;
        else return false;
    }

    return (
        <li>
            <button
                className={'calendar-day' + (isSelected(props.day) ? ' selected' : '') + (isToday(props.day) ? ' today' : '')}
                onClick={() => props.changeDate(props.day)}
            >
                <p className='day-name'>{formatDay(props.day.getDay()).slice(0, 3)}</p>
                <p className='day-number'>{props.day.getDate()}</p>
            </button>
        </li>
    )
}